import { render } from "./Tabory.vue?vue&type=template&id=9c85f204"
import script from "./Tabory.vue?vue&type=script&lang=js"
export * from "./Tabory.vue?vue&type=script&lang=js"

import "./Tabory.vue?vue&type=style&index=0&id=9c85f204&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__